import { LazoPaths } from "@/enums/LazoPaths";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Logout = () => {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    AuthService.logOut();

    navigate(LazoPaths.INDEX);
  }, [navigate]);

  useEffect(() => {
    logout();
  }, [logout]);

  return <>Logout</>;
};
